import * as React from 'react';
// @ts-ignore
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
// @ts-ignore
import BootstrapTable from 'react-bootstrap-table-next';
import { LedgerType, PTOSnapshotType, PtoType } from './types';
import dayjs from 'dayjs';
import IconButton from '../../components/common/IconButton';
import CollapsibleArea from '../../components/common/CollapsibleArea';
import Checkbox from '../../components/common/checkbox';
import axios from 'axios';
import AxiosConfig from '../../utilities/AxiosConfig';
import { FormControl, OverlayTrigger, Popover, Row, Spinner } from 'react-bootstrap';
import Dialog from '../../utilities/Dialog';
import AccessControl from '../../components/common/AccessControl';
import ContactSupportMessage from 'src/components/pto/ContactSupportMessage';
import LedgerStatusChange from 'src/components/pto/LedgerStatusChange';
import PTOAddEditComments from 'src/components/pto/PTOAddEditComments';
import CalendarConflictWarning from 'src/components/pto/CalendarConflictWarning';
import PTOShowComment from 'src/components/pto/PTOShowComment';
import './PTORequestTable.css';
var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

interface IProps {
    handleLedgerStatusChange: Function;
    ledgerReference: any;
    openEditLedger: any;
    setAddLedgerOpen: any;
    tableData: Array<LedgerType>;
    updatePTOData: any;
    isOwnPTO: boolean;
    isInactive: boolean;
    manageUpdating: boolean;
    hasPtoPlan: boolean;
    showMissingPtoPlanModal: boolean;
    setShowMissingPtoPlanModal: (showMissingPtoPlanModal: boolean) => void;
    loading: boolean;
    ptoData: PtoType;
    ptoSnapShot: PTOSnapshotType;
    setPtoData: Function;
    showContactSuportMessage: boolean;
    setShowContactSuportMessage: Function;
    openContactSupportMessage: Function;
    userInfo: any
    showLedgerStatusChangeModal: boolean;
    setShowLedgerStatusChangeModal: Function;
    handleShowLedgerStatusChange: Function;
    saving: boolean;
    showPtoStatusChangeModal: boolean;
    setShowPtoStatusChangeModal: Function;
    sortableData: LedgerType[];
    handlePTOLedgerUpdate: Function;
    handleDateSortOnClick: Function;
    deleteLedgerModal: Function;
    createdByToolTip: Function;
    refreshLedgerEntries: Function;
}

//? LedgerEntry = row
const PTORequestTable: React.FC<IProps> = (props: IProps) => {
    const { handleLedgerStatusChange, openEditLedger, setAddLedgerOpen,
        tableData, isOwnPTO, isInactive, manageUpdating, hasPtoPlan, showMissingPtoPlanModal, setShowMissingPtoPlanModal,
        loading, ptoData, setPtoData, showContactSuportMessage, setShowContactSuportMessage, openContactSupportMessage,
        userInfo, saving, showPtoStatusChangeModal, setShowPtoStatusChangeModal, handleShowLedgerStatusChange, sortableData,
        handleDateSortOnClick, deleteLedgerModal, createdByToolTip, ptoSnapShot, refreshLedgerEntries } = props;
    const [filter, setFilter] = React.useState<any>({
        requested: true,
        approved: false,
        denied: false,
    });
    const [selected, setSelected] = React.useState<any>([]);
    const [isUpdating, setIsUpdating] = React.useState<boolean>(false);
    //r-18-lint-cm
    //eslint-disable-next-line
    const [entryToEdit, setEntryToEdit] = React.useState({} as LedgerType);
    //r-18-lint-cm
    //eslint-disable-next-line
    const [ledgerStatusChangeType, setLedgerStatusChangeType] = React.useState("");
    const [showAddEditComments, setShowAddEditComments] = React.useState(false);
    const [commentStatus, setCommentStatus] = React.useState("");
    const [entryToCommentOn, setEntryToCommentOn] = React.useState({} as LedgerType);
    const [ptoDateSort, setPtoDateSort] = React.useState(true);
    const [deniedAmount, setDeniedAmount] = React.useState(0);

    const handleFilterChange = (name: string, isChecked: boolean) => {
        setFilter({ ...filter, [name]: isChecked });
    }
    let sortableDataCopy: LedgerType[];

    const handleBatchAction = async (newStatus: string) => {
        setIsUpdating(true);
        let total: number = selected.reduce((acc: number, cur: LedgerType) => {
            return acc + cur.quantity;
        }, 0);
        let action: string = newStatus === "Approved" ? "Approve" : "Deny";
        let confirm: any = new Dialog({ type: "confirm", message: `${action} all ${total} hours?`, trueText: "Yes", falseText: "No" });
        let answer: any = await confirm.show();
        let updatedEntry: LedgerType;
        if (answer) {
            let calls: Array<any> = [];
            selected.forEach((ledgerEntry: LedgerType) => {
                updatedEntry = { ...ledgerEntry, status: newStatus };
                updatedEntry.quantity = Number(updatedEntry.quantity);
                calls.push(axios.post(process.env.REACT_APP_API_URL + "/api/pto/ledger", updatedEntry, AxiosConfig.configValue("min")));
            });
            if (calls.length > 0) {
                axios.all(calls)
                    .then((responses: any) => {
                        if (AxiosConfig.checkResponse(responses, { alertOnSuccess: true, successMessage: `Successfully changed status's to ${newStatus}`, snackBar: { manual: true } })) {
                            setSelected([]);
                            responses.forEach((element: any) => {
                                handlePTOLedgerUpdate(element, element.data.LedgerEntry.status);
                            })
                        }
                        setPtoData({ ...ptoData, ledger: sortableDataCopy });
                    })
                    .catch((errors: any) => {
                        AxiosConfig.handleError(errors);
                    })
                    .finally(() => {
                        //cgm 051322 =>> forcing the pto items to update so that they will refresh.
                        handleDateSortOnClick();
                        setIsUpdating(false);

                    });
            } else { setIsUpdating(false); }
        } else { setIsUpdating(false) }
    }

    //cgm 051322 =>> may be able to make handlePTOLedgerUpdate from the manage detail work with a little tweaking
    const handlePTOLedgerUpdate = (ledgerItem: any, status: string) => {
        if (ledgerItem.status === 200) {
            if (sortableData !== undefined && sortableData !== null) { sortableDataCopy = sortableData }
            for (let j = 0; j < sortableDataCopy?.length; j++) {
                if (sortableDataCopy[j].ledgerId === ledgerItem.data.LedgerEntry.ledgerId) {
                    sortableDataCopy[j].status = status
                }
            }
        }
    }

    const selectRow = {
        mode: "checkbox",
        selected: selected.map((row: any) => row.ledgerId),
        bgColor: "#C4C5C6",
        onSelect: (row: any, isSelected: boolean) => {
            if (isSelected) {
                setSelected([...selected, row]);
            } else {
                let filtered: Array<any> = [...selected].filter((i: any) => (
                    i.ledgerId !== row.ledgerId
                ));
                setSelected(filtered);
            }
        },
        onSelectAll: (isSelected: boolean, rows: any) => {
            if (isSelected) {
                setSelected(tableData.filter((ledgerEntry: LedgerType) => {
                    let isValid = true;
                    //cgm040522 => Which Entry types to display on next line. 4 is PTO and 5 is Unpaid Time Off
                    isValid = ledgerEntry.ledgerEntryTypeId === 4 || ledgerEntry.ledgerEntryTypeId === 5;
                    let filterName: string = ledgerEntry.status === "Pending" ? "requested" : ledgerEntry.status === "Approved" ? "approved" : "denied";
                    isValid = filter[filterName] && isValid;
                    return isValid;
                }));
            } else { setSelected([]) }
        },
        selectionRenderer: ({ mode, ...rest }: any) => {
            const p: any = (({ rowIndex, rowKey, ...r }) => r)(rest);
            return (
                <input className="table-select-checkbox" type={mode} {...p} readOnly />
            )
        }
    }

    React.useEffect(() => {
        setIsUpdating(manageUpdating);
        //r-18-lint-cm
        //eslint-disable-next-line
    }, [props.manageUpdating])

    const handleCloseMissingPTOWarning = () => {
        setShowMissingPtoPlanModal(!showMissingPtoPlanModal);
    }

    const sortPtoRequestsByDate = (e: any) => {
        e.stopPropagation()
        setPtoDateSort(!ptoDateSort);
    }

    let deniedTotal = 0;
    React.useEffect(() => {
        if (ptoData.ledger !== undefined) {
            ptoData?.ledger.forEach((element: any) => {
                if (element.status === "Denied") {
                    //r-18-lint-cm
                    //eslint-disable-next-line
                    deniedTotal += element.quantity;
                }
            })
        }
        setDeniedAmount(deniedTotal);
        setSelected([]);
    }, [ptoData, ptoSnapShot.TotalHoursPending]);

    const totalRequests = tableData.filter((ledgerEntry: LedgerType) => {
        return ledgerEntry.ledgerEntryTypeId === 4 || ledgerEntry.ledgerEntryTypeId === 5;
    }).length;
    

    const filteredRequestsPreSort = tableData?.filter((ledgerEntry: LedgerType) => {
        let isValid = true;
        //cgm040522 => Which Entry types to display on next line!  4 is PTO and 5 is Unpaid Time Off
        isValid = ledgerEntry.ledgerEntryTypeId === 4 || ledgerEntry.ledgerEntryTypeId === 5;
        let filterName: string = ledgerEntry.status === "Pending" ? "requested" : ledgerEntry.status === "Approved" ? "approved" : "denied";
        isValid = filter[filterName] && isValid;
        return isValid;
    })
    //cgm 060322 =>> sorting requests via click
    const filteredRequests = ptoDateSort ?
        filteredRequestsPreSort.sort((a: LedgerType, b: LedgerType) => (a.entryDatets / 1000) - ((b.entryDatets / 1000))).reverse() || []
        : filteredRequestsPreSort.sort((a: LedgerType, b: LedgerType) => (b.entryDatets / 1000) - ((a.entryDatets / 1000))).reverse() || []

    const addOrEditComment = (e: any, ledgerItem: LedgerType) => {
        e.stopPropagation();
        setEntryToCommentOn(ledgerItem);
        setShowAddEditComments(!showAddEditComments);
    }

    //cgm =>> popover for viewing employees comments
    const showComment = (ledgerItem: LedgerType, employee: boolean) => {
        let employeeCommentDate = dayjs.utc(ledgerItem.EmployeeCommentDatets);
        let managerCommentDate = dayjs.utc(ledgerItem.ManagerCommentDatets);
        return (
            <Popover id="pto-comment-popover">
                <PTOShowComment
                    ledgerItem={ledgerItem}
                    employee={employee}
                    employeeCommentDate={employeeCommentDate}
                    managerCommentDate={managerCommentDate}
                />
            </Popover>
        )
    }

    //cgm 051022 =>> comment icon display for employee comments
    const commentIcon = (row: LedgerType, employee: boolean) => (
        <div className='employee-comment-div'>
            {
                isOwnPTO ?
                    employee ? //My PTO Employee Comment
                        <i onClick={(e) => {
                            row.employeeComment ?
                                setCommentStatus("Edit Comment")
                                : setCommentStatus("Add Comment")
                            addOrEditComment(e, row);
                        }}
                            onMouseEnter={(e) => {
                            }}
                            className={`material-icons ${row.employeeComment ? "bg-white text-primary" : "bg-white icon-text-color"}`}
                        >
                            {
                                row.employeeComment ?
                                    "announcement"
                                    : "add_comment"
                            }
                        </i>
                        : //My PTO manager comment
                        <i className={`material-icons ${row.managerComment ? "bg-white text-primary" : "bg-white icon-text-color"}`} >
                            announcement
                        </i>
                    : // NOT My PTO
                    employee ? //employee comment
                        <i className={`material-icons ${row.employeeComment ? "bg-white text-primary" : "bg-white icon-text-color"}`}>
                            announcement
                        </i>
                        : //manager comment
                        <i className={`material-icons ${row.managerComment ? "bg-white text-primary" : "bg-white icon-text-color"}`}>
                            announcement
                        </i>
            }
        </div>
    )

    const displayCalendarConflict = (ledgerEntry: LedgerType) => {
        return (
            <Popover id="calendar-conflict" className='pto-calendar-conflict'>
                <CalendarConflictWarning
                    ledgerEntry={ledgerEntry}
                />
            </Popover>
        )
    }

    return (
        <>
            <ToolkitProvider
                keyField={"ledgerId"}
                data={filteredRequests}
                columns={[
                    {
                        classNames: "d-flex",
                        dataField: "status",
                        text: "Status",
                        formatExtraData: isUpdating,
                        formatter: (cell: any, row: any, rowIndex: any, extraData: boolean, index: number) => {
                            return (
                                <Row >
                                    {
                                        isOwnPTO
                                            ?
                                            <i className={`material-icons ${row.status === "Approved" ? "text-success" : row.status === "Denied" ? "text-danger" : "text-warning"}`}>
                                                {row.status === "Approved"
                                                    ? "check_circle"
                                                    : row.status === "Denied"
                                                        ? "cancel"
                                                        : "pending_actions"
                                                }
                                            </i>
                                            :
                                            <i onClick={(e) => handleShowLedgerStatusChange(e, row, "ptoChangeType")}
                                                className={
                                                    row.status === "Approved" ? "text-success material-icons mr-1 action-text"
                                                        : row.status === "Denied" ? "text-danger material-icons mr-1 action-text"
                                                            : "text-warning material-icons mr-1 action-text"
                                                }
                                            >
                                                {
                                                    row.status === "Approved" ? "check_circle"
                                                        : row.status === "Denied" ? "cancel"
                                                            : "pending_actions"
                                                }
                                            </i>
                                    }
                                    {
                                        // isOwnPTO
                                        <>
                                            {   //cgm 051022 =>> if employee comment present then allow for popover with comment
                                                row.employeeComment ?
                                                    <OverlayTrigger trigger={["hover", "focus"]} placement="right" delay={400} overlay={showComment(row, true)} >
                                                        {commentIcon(row, true)}
                                                    </OverlayTrigger>
                                                    : <>{commentIcon(row, true)} </>
                                            }
                                        </>
                                    }
                                    {
                                        //cgm 051222 =>> only showing manager comments for now. They are able to be input via the edit field
                                        <>
                                            {
                                                row.managerComment ?
                                                    <OverlayTrigger trigger={["hover", "focus"]} placement="right" delay={400} overlay={showComment(row, false)} >
                                                        {commentIcon(row, false)}
                                                    </OverlayTrigger>
                                                    : <>{commentIcon(row, false)} </>
                                            }
                                        </>
                                    }
                                    {
                                        <>
                                            {
                                                (row.CalendarConflicts !== null && row.CalendarConflicts?.length) > 0 ?
                                                    <OverlayTrigger trigger={["hover", "focus"]} placement="right" delay={400} overlay={displayCalendarConflict(row)}>
                                                        <i className='material-icons calendar-conflict-icon text-danger'>
                                                            warning
                                                        </i>
                                                    </OverlayTrigger>
                                                    : null
                                            }
                                        </>
                                    }
                                </Row>
                            )
                        }
                    },
                    {
                        dataField: "Date Range",
                        text:
                            <div className='pto-date-div d-flex flex-row'>
                                <h5 className='flex-row'>Date </h5>
                                <div onClick={(e) => sortPtoRequestsByDate(e)} className="date-sort-icon material-icons">
                                    unfold_more
                                </div>
                            </div>
                        ,
                        // formatter: (cell: any, row: any) => dayjs.utc(row.entryDatets).format("MM/DD/YYYY"),
                        formatter: (cell: any, row: any) => {
                            return (
                                <OverlayTrigger trigger={["hover", "focus"]} placement="right" delay={400} overlay={createdByToolTip(row)} >
                                    <div className='pto-date-div-commentsizer'>
                                        {dayjs.utc(row.entryDatets).format("MM/DD/YYYY")}
                                    </div>
                                </OverlayTrigger>
                            )
                        },
                    },
                    {
                        dataField: "Type",
                        text: "Type",
                        //cgm040522 => this only allows for PTO or Unpaid.  Add to ternary for additional ledger types if needed.
                        formatter: (cell: any, row: any) => row.ledgerEntryTypeId === 4 ? "PTO Request" : <span className=''>Unpaid Time Off</span>
                    },
                    {
                        dataField: "quantity",
                        text: "Hours", //cgm040522 =>> Graying out the unpaid items and making all positive
                        formatter: (cell: any, row: any) => row.quantity < 0 ? -row.quantity : row.quantity && row.ledgerEntryTypeId === 5 ? <span className=''>{row.quantity}</span> : row.quantity
                    },
                    {
                        dataField: "Actions",
                        text: "",
                        IsDummyField: true,
                        formatter: (cell: any, row: any) => (
                            <>
                                {(isOwnPTO && row.status !== "Pending")
                                    ?
                                    null
                                    :
                                    row.status === "Pending"
                                        ?
                                        <>
                                            <i className="material-icons action-text-danger" onClick={(e: any) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                deleteLedgerModal(row, "requests-table");
                                            }}>delete</i>
                                            <i className="material-icons action-text" onClick={(e: any) => openEditLedger(e, row)}>edit</i>
                                            {
                                                userInfo.PayTypeId === 1 ?
                                                    (row.timeEntryId === 0 || row.timeEntryId === null) && (row.ledgerEntryTypeId === 4 || row.ledgerEntryTypeId === 5) &&
                                                    <i className="material-icons action-text text-danger blink-me" onClick={(e: any) => openContactSupportMessage()}>
                                                        warning
                                                    </i>
                                                    :
                                                    row.timeEntryId === null &&
                                                    <i className="material-icons action-text text-danger blink-me" onClick={(e: any) => openContactSupportMessage()}>
                                                        warning
                                                    </i>
                                            }
                                        </>
                                        :
                                        <AccessControl target={["HR:ADMIN", "HR:MANAGER"]}>
                                            <>
                                                <i className="material-icons action-text-danger" onClick={(e: any) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    // editLedgerForm.current = ledgerEntry;
                                                    deleteLedgerModal(row, "requests-table");
                                                }}>delete</i>
                                                <i className="material-icons action-text" onClick={(e: any) => openEditLedger(e, row)}>edit</i>
                                                { //cgm 050322 =>> if there isn't a timeEntry ID and the pay type is PTO or unpaid PTO and the user is hourly show this message 
                                                    userInfo.PayTypeId === 1 ?
                                                        (row.timeEntryId === 0 || row.timeEntryId === null) && (row.ledgerEntryTypeId === 4 || row.ledgerEntryTypeId === 5) &&
                                                        <i className="material-icons action-text text-danger blink-me" onClick={(e: any) => openContactSupportMessage()}>
                                                            warning
                                                        </i>
                                                        : null
                                                }
                                            </>
                                        </AccessControl>
                                }
                            </>
                        )
                    }
                ]}
            >
                {(p: any) => (
                    <CollapsibleArea // PTO Requests
                        Toggle={({ onClick, open }: any) => {
                            return (
                                <div className="pto-request-header d-flex flex-wrap align-items-center">

                                    <i onClick={onClick} className="material-icons mr-1 action-text">{open ? "remove_circle_outline" : "add_box"}</i>
                                    <h5 className='pto-request-header-text'>PTO Requests</h5>

                                    {open && <div className="PTORequestTableFilterBtns">
                                        <div className={`PTORequestTableFilterBtn PTORequestTableFilterBtnRequested${filter.requested ? "Checked" : "Unchecked"}`}
                                            onClick={() => handleFilterChange("requested", !filter.requested)}
                                        >
                                            <div className='PTORequestTableFilterBtnTitle'>
                                                <p>Requested</p>
                                            </div>
                                            <div className='PTORequestTableFilterBtnChckbox'>
                                                <FormControl
                                                    checked={filter.requested}
                                                    onChange={() => null}
                                                    type="checkBox"
                                                />
                                            </div>
                                        </div>
                                        <div className={`PTORequestTableFilterBtn PTORequestTableFilterBtnApproved${filter.approved ? "Checked" : "Unchecked"}`}
                                            onClick={() => handleFilterChange("approved", !filter.approved)}
                                        >
                                            <div className='PTORequestTableFilterBtnTitle'>
                                                <p>Approved</p>
                                            </div>
                                            <div className='PTORequestTableFilterBtnChckbox'>
                                                <FormControl
                                                    checked={filter.approved}
                                                    onChange={() => null}
                                                    type="checkBox"
                                                />
                                            </div>
                                        </div>
                                        <div className={`PTORequestTableFilterBtn PTORequestTableFilterBtnDenied${filter.denied ? "Checked" : "Unchecked"}`}
                                            onClick={() => handleFilterChange("denied", !filter.denied)}
                                        >
                                            <div className='PTORequestTableFilterBtnTitle'>
                                                <p>Denied</p>
                                            </div>
                                            <div className='PTORequestTableFilterBtnChckbox'>
                                                <FormControl
                                                    checked={filter.denied}
                                                    onChange={() => null}
                                                    type="checkBox"
                                                />
                                            </div>
                                        </div>
                                    </div>}

                                    {open && <h6 className='pto-table-count' >{filteredRequests.length} of {totalRequests} rows showing </h6>}
                                    {
                                        selected.length > 0 &&
                                        <div className="center" style={{ backgroundColor: "lightgrey", padding: 5, height: 48 }}>
                                            <strong>Apply to Selected: </strong>
                                            <div onClick={() => handleBatchAction("Approved")} className="center action-text mr-1 p-1">
                                                {
                                                    isUpdating
                                                        ? <Spinner size="sm" animation="border" />
                                                        : <i className="material-icons text-success">check_circle</i>
                                                }
                                                <span className="font-bold">Approve</span>
                                            </div>
                                            <div onClick={() => handleBatchAction("Denied")} className="center action-text p-1">
                                                {
                                                    isUpdating
                                                        ? <Spinner size="sm" animation="border" />
                                                        : <i className="material-icons text-danger">cancel</i>
                                                }
                                                <span className="font-bold">Deny</span>
                                            </div>
                                        </div>
                                    }
                                    {
                                        showContactSuportMessage &&
                                        <ContactSupportMessage
                                            showContactSuportMessage={showContactSuportMessage}
                                            setShowContactSuportMessage={setShowContactSuportMessage}
                                            openContactSupportMessage={openContactSupportMessage}
                                        />
                                    }
                                    {
                                        showPtoStatusChangeModal &&
                                        <LedgerStatusChange
                                            ledgerStatusTypes={props.ledgerReference?.ledgerStatusTypes}
                                            ledgerEntry={entryToEdit}
                                            changeType={ledgerStatusChangeType}
                                            saving={saving}
                                            showLedgerStatusChangeModal={showPtoStatusChangeModal}
                                            setShowLedgerStatusChangeModal={setShowPtoStatusChangeModal}
                                            handleLedgerStatusChange={handleLedgerStatusChange}
                                            isOwnPTO={isOwnPTO}
                                            ptoData={ptoData}
                                            isUpdating={isUpdating}
                                            showPtoStatusChangeModal={showPtoStatusChangeModal}
                                            setShowPtoStatusChangeModal={setShowPtoStatusChangeModal}
                                        />
                                    }
                                    {
                                        // showAddEditComments &&
                                        <PTOAddEditComments
                                            showAddEditComments={showAddEditComments}
                                            setShowAddEditComments={setShowAddEditComments}
                                            commentStatus={commentStatus}
                                            saving={saving}
                                            isUpdating={isUpdating}
                                            setIsUpdating={setIsUpdating}
                                            sortableData={sortableData}
                                            ptoData={ptoData}
                                            setPtoData={setPtoData}
                                            ledgerEntry={entryToCommentOn}
                                            refreshData={props.updatePTOData}
                                        />
                                    }
                                    {
                                        (!isInactive && hasPtoPlan) ?

                                            loading ?
                                                <Spinner size="sm" id='request-spinner' className='ml-auto' animation="border" /> :
                                                <IconButton icon="add" className="ml-auto mr-1 action-text center p-1" onClick={() => setAddLedgerOpen(true)}>
                                                    Add Request
                                                </IconButton> :
                                            loading ?
                                                <Spinner size="sm" id='request-spinner' className='ml-auto' animation="border" /> :
                                                <IconButton icon="add" className="ml-auto mr-1 action-text center p-1" onClick={() => handleCloseMissingPTOWarning()}>
                                                    Add Request
                                                </IconButton>
                                    }
                                </div>
                            )
                        }}
                        startOpen
                    >
                        <BootstrapTable
                            id={"requests-table"}
                            bootstrap4 hover striped
                            // rowEvents={rowEvents}
                            // rowClasses={rowClasses ? rowClasses : defaultRowClasses}
                            noDataIndication={() => <span>No Data...</span>}
                            selectRow={isOwnPTO ? undefined : selectRow}
                            {...p.baseProps}
                        />
                    </CollapsibleArea>
                )}

            </ToolkitProvider>
        </>
    );
}

export default PTORequestTable;
